import { ErrorOutline } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import toast from 'react-hot-toast';

const commonToastStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  backgroundColor: '#333',
  color: '#fff',
  borderRadius: '6px',
  padding: '12px',
  minWidth: '500px',
};

const getToastHeight = (message) => {
  if (message.length > 50) return '64px';
  return '44px'; // 1 line
};

export const showSuccessToast = (message, width = 'auto', duration = 3000) => {
  toast.custom(
    (t) => (
      <div
        style={{
          ...commonToastStyles,
          width,
          minHeight: getToastHeight(message),
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          {' '}
          <CheckCircleIcon
            style={{
              color: '#fff',
              marginRight: '8px',
              height: '18px',
              marginTop: '2px', // Added to align with first line of text
            }}
          />
          <span style={{ fontSize: '14px', fontWeight: 400 }}>{message}</span>
        </div>
        <IconButton
          onClick={() => toast.remove(t.id)}
          size="small"
          style={{
            color: '#fff',
            marginLeft: '16px',
            marginTop: '-6px', // Added to align to top
          }}
        >
          <CloseIcon sx={{ fontSize: '20px', width: '20px', height: '20px' }} />
        </IconButton>
      </div>
    ),
    {
      id: 'success-toast',
      position: 'bottom-center',
      duration,
    },
  );
};

/**
 * Shows a success toast for async tasks that create notifications.
 * Has longer duration and includes info about checking notifications.
 */
export const showAsyncTaskToast = (message, width = '500px', duration = 8000) => {
  const fullMessage = `${message} Track progress in the Notifications panel.`;
  toast.custom(
    (t) => (
      <div
        style={{
          ...commonToastStyles,
          width,
          minHeight: getToastHeight(fullMessage),
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <CheckCircleIcon
            style={{
              color: '#4caf50',
              marginRight: '8px',
              height: '18px',
              marginTop: '2px',
            }}
          />
          <span style={{ fontSize: '14px', fontWeight: 400 }}>{fullMessage}</span>
        </div>
        <IconButton
          onClick={() => toast.remove(t.id)}
          size="small"
          style={{
            color: '#fff',
            marginLeft: '16px',
            marginTop: '-6px',
          }}
        >
          <CloseIcon sx={{ fontSize: '20px', width: '20px', height: '20px' }} />
        </IconButton>
      </div>
    ),
    {
      id: `async-task-${Date.now()}`,
      position: 'bottom-center',
      duration,
    },
  );
};

export const showErrorToast = (error, width = 'auto') => {
  const errorMessage = error?.detail?.message || 'Something went wrong. Please try again.';
  toast.custom(
    (t) => (
      <div
        style={{
          ...commonToastStyles,
          width,
          minHeight: getToastHeight(errorMessage),
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          {' '}
          <ErrorOutline
            style={{
              color: '#ff4c4c',
              marginRight: '8px',
              marginTop: '2px', // Added to align with first line of text
            }}
          />
          <span>{errorMessage}</span>
        </div>
        <IconButton
          onClick={() => toast.remove(t.id)}
          size="small"
          style={{
            color: '#fff',
            marginLeft: '16px',
            marginTop: '-6px', // Added to align to top
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>
    ),
    {
      id: 'error-toast',
      position: 'bottom-center',
      duration: 3000,
    },
  );
};
